import styled from 'styled-components'
import 'cloudinary-video-player/cld-video-player.min.css'
import { getCloudinaryImageUrl } from '@utils/images'

const Module3 = (props: any) => {
  return (
    <StyledComponent $block4Image={props.block4Image?.data?.attributes?.url}> {/* 70 is to compensate the header space */}
      <div className='snap-section-start theme-transparent show-floating-logos relative top-[10px]' />
      {/* Tailwind that occupies full width and full height depending on screen size */}
      <div className='wrapper background-image'>
        {props.block4Heading}
      </div>
    </StyledComponent>
  )
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  overflow: hidden;
  > div.wrapper {
    height: 100vh;
  }
 
  .background-image {
    background-image: url(${(props) => props.$block4Image && getCloudinaryImageUrl(props.$block4Image, 'q_auto,dpr_1.0,f_auto')});
    background-repeat: repeat;
    font-family: var(--abcdfont);
    color: white;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 2.5vh;
    line-height: 2.6vh;
    padding: 0 11%;
    background-size: cover;
    background-position: center;

    // Media query for Tablet
    @media (min-width: 768px) {
      font-size: 6.4vh;
      line-height: 5.4vh;
      padding: 0 11%;
      text-align: center;
    }
 
 
    // Media query for desktop
    @media (min-width: 1024px) {
      
    }
  }
`

export default Module3